module.exports = __webpack_public_path__ + "static/media/three_gragons.f474e799.jpeg";